export default __webpack_public_path__ + "static/media/continue-reading.cfd06b83.svg";